// Copyright (c) 2026 Solartek LLC. All rights reserved.

import { registerNamespace } from '@/lib/i18n-namespace';
import en from '@/locales/en/productivity.json';
import ar from '@/locales/ar/productivity.json';

/** Namespace of the Productivity dashboard, the employee's own summary and Settings → Flowza Surveillance. */
export const PRODUCTIVITY_NS = 'productivity';
registerNamespace(PRODUCTIVITY_NS, en, ar);
